// extracted by mini-css-extract-plugin
export var bounce = "_js-1";
export var generatingText = "_js-6";
export var lightning = "_js-4";
export var popup = "_js-5";
export var progressBar = "_js-7";
export var progressFill = "_js-8";
export var progressShimmer = "_js-9";
export var progressText = "_js-a";
export var shimmer = "_js-3";
export var uploadIcon = "_js-0";
export var uploadingText = "_js-2";